<script setup lang="ts">
import EdroneAlert from "edrone-components/EdroneAlert.vue";
import { computed } from "vue";

type Translatable = Record<string, string>;

interface LiveEventTask {
  description: Translatable | string;
  headline: Translatable | string;
}

interface Options {
  options: {
    liveEventTask: LiveEventTask;
  };
}

const props = defineProps<Options>();

const userLang = window?.EDRONE_CONTEXT?.user?.lang || "EN";
const headline = computed(() => {
  if (props.options.liveEventTask.headline && typeof props.options.liveEventTask.headline === "object") {
    return props.options.liveEventTask.headline[userLang] || props.options.liveEventTask.headline.EN || "";
  }
  return props.options.liveEventTask.headline || "";
});

const description = computed(() => {
  if (props.options.liveEventTask.description && typeof props.options.liveEventTask.description === "object") {
    return props.options.liveEventTask.description[userLang] || props.options.liveEventTask.description.EN || "";
  }
  return props.options.liveEventTask.description || "";
});
</script>

<template>
  <div class="tw:flex tw:flex-col tw:gap-5 tw:items-center tw:w-full">
    <div
      class="tw:flex tw:justify-center tw:items-center tw:w-16 tw:h-16 tw:rounded-sm tw:bg-default-000 tw:border tw:border-default-100"
    >
      <div class="tw:w-8 tw:h-8 tw:rounded-full tw:border-2 tw:border-default-500" />
    </div>
    <p class="tw:heading-2 tw:text-black tw:text-center">{{ trans._liveEvents.taskCompleted.title }}</p>
    <EdroneAlert note type="info" class="tw:text-left tw:!items-start" :show-icon="false">
      <template #custom-content>
        <div class="tw:flex tw:gap-2 tw:items-start">
          <font-awesome-icon icon="fa-solid fa-circle" class="tw:text-white tw:p-1" />
          <div class="tw:flex tw:flex-col tw:gap-1">
            <p class="tw:body-1--bold">{{ headline }}</p>
            <p class="tw:caption tw:!text-default-700">
              {{ description }}
            </p>
          </div>
        </div>
      </template>
    </EdroneAlert>
  </div>
</template>
